import { FC, useEffect, useRef } from 'react';
import Typography from '@components/typography';

import { useAppDispatch, useAppSelector } from '@hooks/statehooks';
import { setVehicleInterior } from '@store/reducers/vehicleinterior';
import Loader from '@components/loader/loader';
import { useDeviceDetect } from '@hooks/usedevicedetect';

interface Props {
  modelCode?: number;
  doors?: number;
  train?: string;
  year?: string;
  trim?: string;
}

const Interior: FC<Props> = ({
  modelCode,
  doors,
  train,
  year,
  trim,
}: Props) => {
  const dispatch = useAppDispatch();
  const { loading, interior } = useAppSelector(
    (state) => state.vehicleInterior
  );
  const { isMobile } = useDeviceDetect();
  const inputDisclaimerMessage = isMobile
    ? 'The interior here is just to give you an idea. Not your actual car.'
    : 'The interior here is just to give you an idea, not your actual car. Please use your mouse to interact with the interior.';

  const hasFetchedData = useRef(false);
  const noInteriorView = 'No interior view is available';

  useEffect(() => {
    if (!hasFetchedData.current) {
      if (modelCode) {
        dispatch(setVehicleInterior({ modelCode, doors, trim, train, year }));
      }
    }
  }, []);

  return (
    <div className="image-gallery-container__content-view360-interior">
      {loading ? (
        <Loader />
      ) : (
        <>
          {(!modelCode || !interior) && (
            <Typography size="rg" variant="body1">
              {noInteriorView}
            </Typography>
          )}
          {modelCode && interior && (
            <>
              <p className="image-gallery-container__content-view360-disclaimer">
                {inputDisclaimerMessage}
              </p>
              <iframe
                title="Panoramic view of the vechile interior. Click to interact."
                src={interior.url}
                allowFullScreen
              ></iframe>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Interior;
